
import './MultiIris.css'
import MultiIrisSmall from "./MultiIrisSmall"
import MultiIrisLarge from "./MultiIrisLarge"

function MultiIris() {


    return (
      <div>
        <MultiIrisSmall />
        <MultiIrisLarge />
      </div>
    );
}

export default MultiIris;